import { FC } from 'react';
import { HeroConversationMessage } from '@vs-online-only-app/state';
import { ChatBotMessage } from './ChatBotMessage';

type Props = {
  message: HeroConversationMessage;
};

const InactivityWarningMessage: FC<Props> = ({ message }) => {
  return <ChatBotMessage message={message} />;
};

export default InactivityWarningMessage;
